export default "__VITE_ASSET__BGs9UWGO__"